import { createUseQueryHook } from './createUseQueryHook';

export const usePersonBonusCards = createUseQueryHook('person_bonus_card_list', {
    cacheTime: Infinity,
});
